//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Swiper, { Navigation, Pagination, Autoplay } from 'swiper'
import dayJs from 'dayjs'
import get from 'lodash/get'
import readingTime from 'reading-time'
import hasWindow from '~/mixins/hasWindow'
import { generateImageURL } from '~/utils/storage'

Swiper.use([Navigation, Pagination, Autoplay])

export default {
  mixins: [hasWindow],

  props: { picks: { type: Array, default: () => [] } },

  mounted() {
    this.initSwiper()
  },

  beforeDestroy() {
    this.swiper && this.swiper.destroy()
  },

  methods: {
    get,
    generateImage(url) {
      return `${generateImageURL(url || '')}?&fit=crop`
    },
    getDate(date) {
      return dayJs(date).format('DD MMM YYYY')
    },
    getMinutes(min) {
      return min || 0
    },
    getReadingTime(content) {
      return readingTime(content).text
    },
    getTotalComment(comment) {
      return comment || 0
    },
    initSwiper() {
      this.swiper = new Swiper(this.$el, {
        loop: false,
        autoplay: {
          delay: 3000,
        },
        pagination: { el: '.swiper-pagination' },
        resistanceRatio: 0,
        breakpoints: {
          268: {
            slidesPerView: 1,
          },
          576: {
            slidesPerView: 3,
            spaceBetween: 25,
          },
        },
      })
    },
  },
}
